import { Settings } from '@/app/lib/settings';

/**
 * Prismic link resolver
 * Preference order:
 * 1) Use Prismic's resolved `document.url` (populated when `routes` are configured on the client)
 * 2) Fallback to manual mapping below
 */
export const linkResolver = (document) => {
	if (!document) return '/';

	// If Prismic already resolved a URL (via `routes`), use it
	if (document.url) return document.url;

	if (document.isBroken) {
		return `/`;
	}

	if (document.uid === 'homepage') return '/';

	// Pages
	if (document.type === 'page') {

		return `/${document.uid}`;
	}

	// Highlights: nested under event when present
	if (document.type === 'highlight') {
		if (document.data?.event?.uid) {
			return `/${Settings.eventsPrefix}/${document.data.event.uid}/highlights/${document.uid}`;
		}
		return `/${document.uid}`;
	}

	// Events
	if (document.type === 'event') {
		return `/${Settings.eventsPrefix}/${document.uid}`;
	}

	// Projects
	if (document.type === 'project') {
		return `/${Settings.projectsPrefix}/${document.uid}`;
	}

	// Sessions: nested under event when present
	if (document.type === 'session') {
		if (document.data?.event?.uid) {
			return `/${Settings.eventsPrefix}/${document.data.event.uid}/${Settings.sessionsPrefix}/${document.uid}`;
		}
		// Fallback if no event is linked
		return `/${Settings.sessionsPrefix}/${document.uid}`;
	}

	// Stories
	if (document.type === 'story') {
		return `/${Settings.storiesPrefix}/${document.uid}`;
	}

	// Default
	return '/';
};